export enum DocumentTypeEnum {
  InsurancePolicy = 'INSURANCE_POLICY',
  RegistrationObverse = 'REGISTRATION_OBVERSE',
  RegistrationReverse = 'REGISTRATION_REVERSE',
}
